import {defaultBrand} from '@daedalus/core/src/brand/config'

export default defaultBrand
